import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Typography,
} from '@mui/material';
import React from 'react';
import useLocalization from 'hooks/useLocalization';

interface UniformParamValueNoticeDialogProps {
  open: boolean;
  dontShowAgain: boolean;
  onDontShowAgainChange: (checked: boolean) => void;
  onConfirm: () => void;
  onClose: (_: object, reason: 'backdropClick' | 'escapeKeyDown') => void;
}

const UniformParamValueNoticeDialog: React.FC<UniformParamValueNoticeDialogProps> = ({
  open,
  dontShowAgain,
  onDontShowAgainChange,
  onConfirm,
  onClose,
}) => {
  const { currentLocale } = useLocalization();
  const loc = React.useMemo(
    () => currentLocale.settingsPopup.massMessagingTasks.taskUsersTable.uniformParamNotice,
    [currentLocale],
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="uniform-param-notice-title"
      PaperProps={{
        sx: (theme) => ({
          borderRadius: 2,
          border: `1px solid ${theme.palette.divider}`,
          boxShadow: theme.shadows[8],
        }),
      }}
    >
      <DialogTitle id="uniform-param-notice-title" sx={{ pb: 1, fontWeight: 600 }}>
        {loc.title}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" component="div" sx={{ lineHeight: 1.65 }}>
          {loc.body}
        </Typography>
        <FormControlLabel
          sx={{ mt: 2, alignItems: 'flex-start', mr: 0 }}
          control={
            <Checkbox
              size="small"
              checked={dontShowAgain}
              onChange={(_, checked) => onDontShowAgainChange(checked)}
            />
          }
          label={
            <Typography variant="body2" color="text.secondary">
              {loc.dontShowAgain}
            </Typography>
          }
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5, pt: 0, justifyContent: 'flex-end' }}>
        <Button variant="contained" color="primary" onClick={onConfirm} autoFocus>
          {loc.confirm}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UniformParamValueNoticeDialog;
